export default __webpack_public_path__ + "adobe-audition.a8b71167.png";